import { Dialog, Transition } from "@headlessui/react";
import React, { FC, Fragment, ReactNode } from "react";

import { ModalHead } from "@/components/molecules/modals/Modal";

interface Props {
  isOpen: boolean;
  close: () => void;
  title: string;
  children: ReactNode;
  showCloseIcon?: boolean;
}

export const BasicModal: FC<Props> = ({
  isOpen,
  close,
  title,
  children,
  showCloseIcon = true,
}) => {
  return (
    <>
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={() => close()}>
          <div className="fixed inset-0 bg-black/50" />
          <div className="overflow-y-auto fixed inset-0">
            <div className="flex justify-center items-center p-4 min-h-full text-center">
              <Dialog.Panel className="overflow-hidden relative min-w-[50%] max-h-[90vh] text-left align-middle bg-white rounded-lg drop-shadow-[0_1px_5px_rgba(0,0,0,0.15)] transition-all">
                <ModalHead
                  title={title}
                  onClickClose={close}
                  showCloseIcon={showCloseIcon}
                />
                {children}
              </Dialog.Panel>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
};
